import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { Icon, InputWithIcon, SelectMenu, BasicTooltip, DatePicker, toast, TableLoader } from '@livable/saas-react-components';
import { Button, Container, MenuItem, TextField, Chip } from '@mui/material';
import ChargeMenu from './ChargeMenu';
import EditModal from './EditModal';
import CancelModal from './DeleteModal';
import { DataGrid } from '@mui/x-data-grid';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { useTranslation } from 'react-i18next';
import moment from 'moment/moment';
import { RECCURING_TRANSACTION_ENDING_CONDITION, RECCURING_TRANSACTION_STATUS, RECCURING_TRANSACTION_ENDING_CONDITION_KEYS } from 'src/constants/payments';
export const ReccuringChargesTable = observer(_ref => {
  let accountId = _ref.accountId,
    triggerRefresh = _ref.triggerRefresh;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState('all'),
    _useState4 = _slicedToArray(_useState3, 2),
    type = _useState4[0],
    setType = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    rows = _useState6[0],
    setRows = _useState6[1];
  const _useState7 = useState(moment(store.properties.serverBusinessDateOnly).startOf('month').subtract(12, 'month').toDate()),
    _useState8 = _slicedToArray(_useState7, 2),
    fromDate = _useState8[0],
    setFromDate = _useState8[1];
  const _useState9 = useState(moment(store.properties.serverBusinessDateOnly).endOf('month').toDate()),
    _useState0 = _slicedToArray(_useState9, 2),
    toDate = _useState0[0],
    setToDate = _useState0[1];
  const _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    searchKey = _useState10[0],
    setSearchKey = _useState10[1];
  const _useState11 = useState({}),
    _useState12 = _slicedToArray(_useState11, 2),
    activeTransaction = _useState12[0],
    setActiveTransaction = _useState12[1];
  const _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    editModalState = _useState14[0],
    setEditModalState = _useState14[1];
  const _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    cancelModalState = _useState16[0],
    setCancelModalState = _useState16[1];
  const invokeEditModal = () => {
    setEditModalState(true);
  };
  const invokeCancelModal = () => {
    setCancelModalState(true);
  };
  const handleSearchKeyChange = event => {
    var _event$target;
    setSearchKey((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
  };
  const handleTypeChange = event => {
    if (event.target.value) setType(event.target.value);
  };
  const handleDateChange = d => {
    if (d.startDate) {
      setFromDate(moment("".concat(d.startDate)).startOf('day').toDate());
    }
    if (d.endDate) {
      setToDate(moment("".concat(d.endDate)).endOf('day').toDate());
    }
  };
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign && classes.rightAlign
  }, text);
  const renderCell = (parameter, left) => /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(left && classes.cellLeft)
  }, parameter);
  const renderTooltipCell = (parameter, left) => /*#__PURE__*/React.createElement(BasicTooltip, {
    title: parameter,
    placement: "top-start"
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(classes.dotsOverflow, " ").concat(left && classes.cellLeft)
  }, parameter));
  const getEndingDateOnly = row => {
    switch (row.endingCondition) {
      case RECCURING_TRANSACTION_ENDING_CONDITION_KEYS.OnDate:
        {
          return row.endingDateOnly !== null ? moment(row.endingDateOnly).format('MM/DD/YYYY') : RECCURING_TRANSACTION_ENDING_CONDITION[row.endingCondition];
        }
      case RECCURING_TRANSACTION_ENDING_CONDITION_KEYS.OnMoveOut:
        {
          return row.endingDateOnly !== null ? moment(row.endingDateOnly).format('MM/DD/YYYY') : RECCURING_TRANSACTION_ENDING_CONDITION[row.endingCondition];
        }
      case RECCURING_TRANSACTION_ENDING_CONDITION_KEYS.OnNumberOfOccurrences:
      default:
        {
          return RECCURING_TRANSACTION_ENDING_CONDITION[row.endingCondition];
        }
    }
  };
  const columns = [{
    field: 'postTime',
    flex: 1,
    maxWidth: 200,
    headerName: t('resident_account.post_time'),
    renderCell: params => renderCell(moment(params.row.postTime).format('MM/DD/YYYY hh:mm A'), true),
    renderHeader: () => renderHeader(t('resident_account.post_time'))
  }, {
    field: 'title',
    flex: 1,
    maxWidth: 240,
    headerName: t('resident_account.title'),
    renderCell: params => {
      var _params$row$title, _params$row;
      return renderTooltipCell((_params$row$title = (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.title) !== null && _params$row$title !== void 0 ? _params$row$title : 'Some long recurring charge title with tooltip', true);
    },
    renderHeader: () => renderHeader(t('resident_account.title'))
  }, {
    field: 'amount',
    align: 'right',
    headerAlign: 'right',
    flex: 1,
    maxWidth: 100,
    headerName: t('resident_account.amount'),
    renderCell: params => renderCell("$".concat(Number(params.row.amount).toFixed(2))),
    renderHeader: () => renderHeader(t('resident_account.amount'))
  }, {
    field: 'postType',
    flex: 1,
    maxWidth: 100,
    headerName: 'Type',
    renderCell: params => renderCell(params.row.postType, true),
    renderHeader: () => renderHeader('Type')
  }, {
    field: 'repeatRate',
    flex: 1,
    maxWidth: 120,
    headerName: t('resident_account.frequency'),
    renderCell: params => renderCell(params.row.repeatRate !== 'Month' && params.row.repeatOnMonth !== null ? "".concat(params.row.repeatRate, ": ").concat(moment().month(params.row.repeatOnMonth - 1).format('MMMM')) : "".concat(params.row.repeatRate), true),
    renderHeader: () => renderHeader(t('resident_account.frequency'))
  }, {
    field: 'startedDateOnly',
    flex: 1,
    maxWidth: 120,
    headerName: t('resident_account.starts_from'),
    renderCell: params => renderCell(moment(params.row.startedDateOnly).format('MM/DD/YYYY'), true),
    renderHeader: () => renderHeader(t('resident_account.starts_from'))
  }, {
    field: 'endingDateOnly',
    flex: 1,
    maxWidth: 125,
    headerName: t('resident_account.ends'),
    renderCell: params => renderTooltipCell(getEndingDateOnly(params.row), true),
    renderHeader: () => renderHeader(t('resident_account.ends'))
  }, {
    field: 'memoAndNote',
    align: 'right',
    headerAlign: 'right',
    flex: 1,
    maxWidth: 125,
    headerName: t('resident_account.memo_and_note'),
    renderCell: params => /*#__PURE__*/React.createElement("div", {
      className: classes.cellContent
    }, params.row.memo && /*#__PURE__*/React.createElement(BasicTooltip, {
      title: params.row.memo,
      placement: "top"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      'custom-attribute': '120-reccuring-charges-table'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "memo"
    }))), params.row.notes && /*#__PURE__*/React.createElement(BasicTooltip, {
      title: params.row.notes,
      placement: "top"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      'custom-attribute': '121-reccuring-charges-table'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "note"
    })))),
    renderHeader: () => renderHeader(t('resident_account.memo_and_note'))
  }, {
    field: 'toolbox',
    align: 'right',
    headerAlign: 'right',
    flex: 1,
    maxWidth: 150,
    headerName: t('resident_account.toolbox'),
    readOnly: true,
    renderCell: params => {
      var _params$row2;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.cellContent
      }, params.row.status === RECCURING_TRANSACTION_STATUS.Active && /*#__PURE__*/React.createElement(ChargeMenu, {
        params: params.row,
        key: "ChargeMenu_".concat((_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.id),
        setActiveTransaction: setActiveTransaction,
        invokeEditModal: invokeEditModal,
        invokeCancelModal: invokeCancelModal
      }), params.row.status === RECCURING_TRANSACTION_STATUS.Inactive && /*#__PURE__*/React.createElement(Chip, {
        label: t('resident_account.canceled'),
        variant: "inactive"
      }));
    },
    renderHeader: () => renderHeader(t('resident_account.toolbox'))
  }];
  const parseData = data => {
    setRows(data.map(datum => {
      return _objectSpread(_objectSpread({}, datum), {}, {
        id: datum.id,
        postTime: datum.postTime,
        amount: datum.amount,
        postType: datum.postType,
        repeatRate: datum.repeatRate,
        startedDateOnly: datum.startedDateOnly,
        endingDateOnly: datum.endingDateOnly,
        status: datum.status,
        endingCondition: datum.endingCondition,
        nextScheduledDateOnly: datum.nextScheduledDateOnly,
        endingNumberOfOccurrences: datum.endingNumberOfOccurrences,
        monthlyRepeatCondition: datum.monthlyRepeatCondition,
        occuredTimes: datum.occuredTimes,
        memo: datum.memo,
        notes: datum.notes,
        repeatOnMonth: datum.repeatOnMonth,
        deactivationInfo: datum.deactivationInfo
      });
    }));
  };
  const fetchData = async () => {
    setIsLoading(true);
    const getRecurringTransactionsResp = await store.transaction.getRecurringTransactionsAsync.run({
      residentAccountId: accountId
    });
    if (getRecurringTransactionsResp !== null && getRecurringTransactionsResp !== void 0 && getRecurringTransactionsResp.isSuccessful) {
      parseData(getRecurringTransactionsResp.response);
    }
    setIsLoading(false);
  };
  const handleEditRecurringModalUpdate = async props => {
    const updateRecurringTransactionsResp = await store.transaction.updateRecurringTransactionsAsync.run(_objectSpread({}, props));
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    (updateRecurringTransactionsResp === null || updateRecurringTransactionsResp === void 0 ? void 0 : updateRecurringTransactionsResp.isSuccessful) && toast('success', {
      body: ['Successfully saved']
    });
    fetchData();
  };
  const handleCancelRecurringModalUpdate = async props => {
    const cancelRecurringTransactionsResp = await store.transaction.cancelRecurringTransactionsAsync.run(_objectSpread({}, props));
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    (cancelRecurringTransactionsResp === null || cancelRecurringTransactionsResp === void 0 ? void 0 : cancelRecurringTransactionsResp.isSuccessful) && toast('success', {
      body: ['Successfully canceled']
    });
    fetchData();
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerRefresh]);
  return /*#__PURE__*/React.createElement(Container, {
    className: classes.pageContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchBar
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchField
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "charges-search",
    label: t('general.search'),
    variant: "outlined",
    value: searchKey,
    onChange: handleSearchKeyChange,
    fullWidth: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.filterSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "type-selector",
    value: type,
    label: "Type",
    labelId: "type-selector-label",
    onChange: handleTypeChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "all"
  }, t('general.all_types')), /*#__PURE__*/React.createElement(MenuItem, {
    value: "charge"
  }, t('general.charge')), /*#__PURE__*/React.createElement(MenuItem, {
    value: "credit"
  }, t('general.credit')))), /*#__PURE__*/React.createElement("div", {
    className: classes.datePicker
  }, /*#__PURE__*/React.createElement(DatePicker, {
    label: t('general.starts_from'),
    format: "MMMM yyyy",
    value: fromDate,
    onChange: startDate => handleDateChange({
      startDate
    }),
    showMonthYearPicker: true
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.datePicker
  }, /*#__PURE__*/React.createElement(DatePicker, {
    label: t('general.ends'),
    format: "MMMM yyyy",
    value: toDate,
    onChange: endDate => handleDateChange({
      endDate
    }),
    showMonthYearPicker: true
  }))), isLoading ? /*#__PURE__*/React.createElement(TableLoader, null) : /*#__PURE__*/React.createElement("div", {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(DataGrid, {
    loading: isLoading,
    getRowId: row => row === null || row === void 0 ? void 0 : row.id,
    rows: rows.filter(i => {
      const searchPhrase = new RegExp(searchKey, 'gi');
      return searchKey.length > 0 ? " ".concat(i.title).search(searchPhrase) > 0 : true;
    }).filter(i => {
      return type === 'all' ? true : i.postType.toLowerCase() === type;
    }).filter(i => {
      return moment(i.startedDateOnly).isBetween(fromDate, toDate, null, []) || moment(i.endingDateOnly).isBetween(fromDate, toDate, null, []);
    }),
    columns: columns,
    pageSize: 10,
    rowsPerPageOptions: [5, 10, 20],
    disableRowSelectionOnClick: true,
    autoHeight: true,
    columnHeaderHeight: 52,
    rowHeight: 73,
    hideFooterSelectedRowCount: true,
    slots: {
      BaseButton: props => /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        variant: "actionButton",
        'custom-attribute': '122-reccuring-charges-table'
      })),
      BaseTextField: props => /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
        variant: "outlined"
      }))
    },
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    }
  })), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EditModal, {
    key: "EditReoccurringCharge",
    activeTransaction: activeTransaction,
    handleCloseExternal: () => setEditModalState(false),
    onSaveHandler: handleEditRecurringModalUpdate,
    modalState: editModalState
  }), /*#__PURE__*/React.createElement(CancelModal, {
    key: "CancelReoccurringCharge",
    activeTransaction: activeTransaction,
    handleCloseExternal: () => setCancelModalState(false),
    onSaveHandler: handleCancelRecurringModalUpdate,
    modalState: cancelModalState
  })));
});